"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.msToHours = exports.hourToMs = exports.minToMs = exports.msToMin = exports.sleep = exports.timeout = void 0;
const timeout = (prom, timeoutMS, customErrorMessage, timeoutCallback) => {
    let timer;
    return Promise.race([
        prom,
        new Promise((resolve, reject) => (timer = setTimeout(() => {
            if (timeoutCallback) {
                return timeoutCallback(resolve, reject);
            }
            reject(new Error(customErrorMessage ?? `Timeout error ${timeoutMS} [MS]`));
        }, timeoutMS))),
    ]).finally(() => clearTimeout(timer));
};
exports.timeout = timeout;
const sleep = (ms) => new Promise((resolve, _rejects) => setTimeout(resolve, ms));
exports.sleep = sleep;
const msToMin = (ms) => ms / 60000;
exports.msToMin = msToMin;
const minToMs = (min) => min * 60000;
exports.minToMs = minToMs;
const hourToMs = (hours) => hours * 3600000;
exports.hourToMs = hourToMs;
const msToHours = (ms) => ms / 3600000;
exports.msToHours = msToHours;
//# sourceMappingURL=time.js.map